import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';
import formSportRoomConfigContent from './formSportRoomConfigContent';
import formSportRoomConfigContentMassUpdate from './formSportRoomConfigContentMassUpdate';

export default {
  attributeName: 'sportRoomsConfigContentTable',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:true,
  secondaryButtonText:'Mass update',
  popupContentFormNew:[formSportRoomConfigContent],
  popupContentFormEdit:[formSportRoomConfigContent],
  popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  editURL:'liveSportRoomContent',
  getURL:'liveSportRoomContent',
  updateURL:'liveSportRoomContent',
  removeURL:'liveSportRoomContent',
  secondaryParamUrl:'massUpdate',

  deleteRecordText:"You are about to delete the content from this live. Are you totally sure?",
  sessionParams: [],
  emptyMessage: "You don't have Rooms configs contents linked with this live event, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      type: FormInputTypes.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Content id.',
    },
    {
      attributeName: 'whiteLabelPro',
      label: 'White Label Pro Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'hite Label Pro Name of config.',
    },
    {
      attributeName: 'sportRoomName',
      label: 'Room Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'configName',
      label: 'Config Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'name',
      label: 'Content name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'url',
      label: 'Url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the Url.',
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation',
      type: FormInputTypes.TIMESTAMP,
      canOrder: false,
      helpText: 'Activation of content.',
    },
    {
      attributeName: 'startEpoch',
      label: 'Starting',
      type: FormInputTypes.TIMESTAMP,
      canOrder: false,
      canFilter: false,
      helpText: 'Activation of content.',
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expiration',
      type: FormInputTypes.TIMESTAMP,
      canOrder: false,
      canFilter: false,
      helpText: 'Expiration of the content.',
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.PLAYERICONS,
      canOrder: false,
      canFilter: false,
      helpText: 'Status of live event.',
    },    
    {
      attributeName: 'contentLink',
      label: 'Content link',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Go to content page.',
    },    
  ],
};
